module.exports = __webpack_public_path__ + "static/media/iconDownloadStepHorizonal.beeddc4a.svg";